import store from "../store/store";

const storeHelper = {
    install(Vue, options) {
        Vue.prototype.$replaceUrlTemplate = (url, newValue) => {
            const regex = /\[.+?\]/;
            const modifiedUrl = url.replace(regex, `${newValue}`);
            return modifiedUrl;
        };
        Vue.prototype.$getUserType = () => {
            const userType = JSON.parse(
                    localStorage.getItem(`${process.env.VUE_APP_ACCESS_TOKEN_NAME}User`)
                ).userType;
                
                const role = localStorage.getItem(
                    `${process.env.VUE_APP_ACCESS_TOKEN_NAME}Role`
                );
                
                let user = "";
                if(role === "Org Owner"){
                    user = "org-owner"
                }
                else {
                    if (userType === "doctor") {
                        user = "doctor";
                    } 
                    else if(userType === "basic"){
                        user = "basic";
                    }
                    else if(userType === "superAdmin"){
                        user = "super-admin/store";
                    }
                    else {
                        user = "nurse";
                    }
                }
              
                return user
        };
        Vue.prototype.$isSuperAdmin = () => {

            const userType = JSON.parse(
                localStorage.getItem(`${process.env.VUE_APP_ACCESS_TOKEN_NAME}User`)
            ).userType;

            return userType === "superAdmin";
        };
        Vue.prototype.$isDoctorEMR = () => {
            return JSON.parse(
                localStorage.getItem(`${process.env.VUE_APP_ACCESS_TOKEN_NAME}User`)
            ).doctorEMRClinics.length > 0;
        }
        Vue.prototype.$isClinicOrderApprovalFlowEnabled = isClinicOrderApprovalFlowEnabled;
    },
};

export async function isClinicOrderApprovalFlowEnabled(clinicId) {
    try {
        if (!clinicId) {
            clinicId = sessionStorage.getItem("doctorClinicSelectedClinic");
        }

        if (clinicId) {
            const clinicDetails = await store.dispatch("clinic/fetchClinicsDetail", clinicId);
            return clinicDetails.data.data.doctorApprovalFlowEnabled || false;
        }

        return false;
    } catch (error) {
        console.error("Error fetching clinic details:", error);
        throw error;
    }
}

export default storeHelper;
